import type { StaffRole } from '@/types';

export function isManagerRole(role: StaffRole | undefined): boolean {
  return role === 'owner' || role === 'manager';
}

export function canManageStaff(role: StaffRole | undefined): boolean {
  return isManagerRole(role);
}

export function canManageInventory(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'storekeeper';
}

export function canRecordExpense(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'cashier';
}

export function canManageFinance(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'cashier' || role === 'billing';
}

export function canSchedule(role: StaffRole | undefined): boolean {
  return (
    isManagerRole(role) ||
    role === 'receptionist' ||
    role === 'therapist' ||
    role === 'doctor' ||
    role === 'nutritionist' ||
    role === 'assistant'
  );
}

export function canClinical(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'therapist' || role === 'doctor' || role === 'nutritionist';
}

// --- Page-level view permissions ---

export function canViewPatients(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'receptionist' || canClinical(role) || role === 'cashier' || role === 'assistant';
}

export function canViewSchedule(role: StaffRole | undefined): boolean {
  return canSchedule(role);
}

export function canViewClinical(role: StaffRole | undefined): boolean {
  return canClinical(role);
}

export function canViewNutrition(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'nutritionist';
}

export function canViewBilling(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'receptionist' || role === 'cashier' || role === 'billing';
}

export function canViewFinance(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'cashier' || role === 'billing';
}

export function canViewReports(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'billing';
}

export function canViewInventory(role: StaffRole | undefined): boolean {
  return canManageInventory(role);
}

export function canViewServices(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'receptionist' || role === 'cashier' || role === 'billing';
}

export function canViewFiles(role: StaffRole | undefined): boolean {
  return isManagerRole(role) || role === 'receptionist' || canClinical(role) || role === 'assistant';
}

export function canViewEmployees(role: StaffRole | undefined): boolean {
  return canManageStaff(role);
}
